import { isNative } from './platform';

interface ShareOptions {
  pageName:  string;
  reading:   string;
  signEmoji?: string;
}

/**
 * Share a reading via WhatsApp.
 * - On native: triggers the native share sheet.
 * - On web: opens WhatsApp with plain text + link.
 */
export async function shareOnWhatsApp({ pageName, reading, signEmoji = '✦' }: ShareOptions) {
  const snippet = reading.length > 280 ? reading.slice(0, 277) + '…' : reading;
  const text    = `${signEmoji} *${pageName}*, Professya\n\n${snippet}\n\n✨ Descubra a sua Professya:\nhttps://professya.com?utm_source=whatsapp&utm_medium=share&utm_campaign=professya\n\n_Professya_ #Professya`;

  if (isNative && navigator.share) {
    await navigator.share({ title: pageName, text });
    return;
  }

  const encoded = encodeURIComponent(text);
  window.open(`https://wa.me/?text=${encoded}`, '_blank', 'noopener,noreferrer');
}
